export default __webpack_public_path__ + "static/media/AreaFaith.5682ae02.svg";